export default __webpack_public_path__ + "static/media/userfilledimage.0ec713b3.svg";